import { format } from 'date-fns';
import Tag from '../../../../atom/Tag/Tag';
import styles from './Component.module.scss';
import Toggle from 'component/atom/forms/toggle/Toggle';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import getFileType from 'helpers/getFileType';
import formatFileSize from 'helpers/formatFileSize';
import Loader from 'component/atom/loader/Loader';
import Tooltip from 'component/Custom/tooltip/Tooltip';
import moment from 'moment';
import Pill from './pill/Pill';
import { Link } from 'react-router-dom';
export const formatDateTime = (dateString) => {
  try {
    const date = new Date(dateString);
    return format(date, 'dd/MM/yyyy');
  } catch (e) {
    return '';
  }
};

const BADGE_COLORS = [
  '#264BE1',
  '#E16507',
  '#8F26E1',
  '#00A106',
  '#0BBFBC',
  '#A14400',
  '#0095A1',
  '#909090',
  '#84CC16',
  '#EC4899',
  '#3B82F6',
  '#10B981',
];

const hashString = (s) => {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h * 16777619) >>> 0;
  }
  return h >>> 0;
};

const getColorForKey = (key) => {
  const str = String(key ?? '');
  const idx = hashString(str) % BADGE_COLORS.length;
  return BADGE_COLORS[idx];
};
const isDataUrl = (s) => typeof s === 'string' && /^data:.*;base64,/.test(s);

const base64ByteSize = (data) => {
  const b64 = data.includes(',') ? data.split(',')[1] : data;
  const padding = (b64.match(/=+$/) || [''])[0].length;
  return Math.floor((b64.length * 3) / 4) - padding;
};

const mimeFromDataUrl = (s) =>
  (s.match(/^data:([^;]+);base64,/) || [, 'application/octet-stream'])[1];

const extFromMime = (mime) => {
  const map = {
    'application/pdf': 'pdf',
    'image/png': 'png',
    'image/jpeg': 'jpg',
    'image/webp': 'webp',
    'text/plain': 'txt',
  };
  return map[mime] || 'bin';
};
export const renderTableData = ({
  item,
  header,
  handleSwitch,
  rowKey,
  tableName,
  hasCheckbox,
  index,
  blockDelete,
  hasFileModal,
  isFirstExpandableCell,
}) => {
  const renderItem = (data, headerItem) => {
    const style = {
      fontSize: headerItem?.fontSize ?? 'var(--font-size-14)',
      fontWeight: headerItem?.fontWeight ?? '400',
    };

    return (
      <span
        style={style}
        className={
          isFirstExpandableCell ? styles.expandableFirstCellText : undefined
        }
        dangerouslySetInnerHTML={{ __html: data?.[headerItem.fieldName] ?? '' }}
      />
    );
  };

  const renderBadge = (data, headerItem) => {
    const value = data[headerItem.fieldName];
    return <Pill label={value} variant={getColorForKey(value)} />;
  };

  const renderFileLink = (data, headerItem) => {
    return (
      <div className={styles['file-link']}>
        <SvgWithBranding type='fileCheck' color='#0744E1' onClick={() => {}} />
        <span className={styles['link']}>{data[headerItem.fieldName]}</span>
      </div>
    );
  };

  if (header.isDataType) {
    if (item?.isURL && item?.isFolder) {
      return 'URL';
    }
    if (item?.isFolder) {
      return 'Folder';
    }

    if (!item?.isFolder && !item?.isURL) {
      return getFileType(item['materialFileName']);
    }
  } else if (header.isFileSize) {
    if (tableName === 'Knowledge Base' && item?.fileSize === 0) {
      return '-';
    }
    if (item.fileSize) {
      return formatFileSize(item.fileSize);
    }
  } else if (header.isConnectionType) {
    if (item.isTestConnection) {
      return <Pill label='Test' variant='#0957D0' />;
    }
    return <Pill label='Sync' variant='#00A106' />;
  }
  if (header.fieldName !== 'folderName') {
    if (
      item[header.fieldName] === null ||
      item[header.fieldName] === undefined
    ) {
      if (header?.fieldName === 'CV' && hasFileModal) {
        return 'No File';
      }
      return '-';
    }
  }
  // if (header.fieldName === 'CV') {
  //   const val = item[header.fieldName];
  //   const looksBase64 =
  //     isDataUrl(val) || /^[A-Za-z0-9+/=\s]{100,}$/.test(String(val));

  //   if (!looksBase64) {
  //     return (
  //       <Link className={styles.truncate} to={String(val)}>
  //         {String(val)}
  //       </Link>
  //     );
  //   }

  //   const mime = isDataUrl(val) ? mimeFromDataUrl(val) : 'application/pdf';
  //   const ext = extFromMime(mime);
  //   const bytes = base64ByteSize(String(val));
  //   const pretty = formatFileSize(bytes);
  //   const label = `${ext.toUpperCase()} • ${pretty}`;

  //   const handleClick = (e) => {
  //     e.stopPropagation();
  //   };

  //   return (
  //     // <button
  //     //   className={styles.cvChip}
  //     //   onClick={handleClick}
  //     //   title='Download CV'
  //     // >
  //     //   <SvgWithBranding type='download-file-SVG' />
  //     // </button>
  //     <span>file</span>
  //   );
  // }
  if (header.hasMobile) {
    return item[header.fieldName];
  } else if (header.isDatetime) {
    const dateValue = item[header.fieldName];

    return (
      <div className={styles['date-time-container']}>
        <div className={styles['date-container']}>
          <SvgWithBranding
            type='calendar2'
            className={styles['calendar-icon']}
          />
          <span className={styles['date']}>{formatDateTime(dateValue)}</span>
        </div>
        <div className={styles['date-container']}>
          <SvgWithBranding type='clock2' className={styles['clock-icon']} />
          <span className={styles['time']}>
            {moment(item[header.fieldName]).format('hh:mm:ss A')}
          </span>
        </div>
      </div>
    );
  } else if (header.hasTag) {
    return (
      <div>
        <Tag variant={item[header.fieldName]} label={item[header.fieldName]} />
      </div>
    );
  } else if (header.isSwitch) {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <Tooltip
          placement='top'
          content={
            item['isSystem'] === true
              ? "System workflows can't be deactivated"
              : null
          }
          disabled={
            item['isSystem'] === false || item['isSystem'] === undefined
          }
        >
          <Toggle
            value={item[header.fieldName]}
            onChange={(e) => handleSwitch(item[rowKey], item[header.fieldName])}
            disabled={
              header.fieldName === 'status' && item['isSystem'] === true
                ? true
                : false
            }
          />
        </Tooltip>
      </div>
    );
  } else if (header.hasImage) {
    return (
      <div
        className={`${styles.imgCont} ${
          blockDelete && hasCheckbox ? styles['has-margin'] : ''
        }`}
      >
        <div className={styles['user-initials']}>
          {item['firstName'].charAt(0)}
          {item['lastName'].charAt(0)}
        </div>
        <span className={styles['image-title']}>{item[header.fieldName]}</span>
      </div>
    );
  } else if (header.hasSvg) {
    return (
      <div className={styles.imgCont}>
        {item?.isLoading && (
          <Loader style={{ width: '30px', height: '30px' }} />
        )}
        {!item?.isLoading && (
          <div>
            <SvgWithBranding
              type={
                item.isURL
                  ? 'url'
                  : item.isFolder
                    ? header.primeIcon
                    : header.secondaryIcon
              }
              color='#0957D0'
              className={styles.icon}
            />
          </div>
        )}
        {item?.isFolder || item?.isURL
          ? item[header.fieldName]
          : item['materialFileName']}
      </div>
    );
  } else if (header.hasFile) {
    return (
      <div className={styles.fileCont}>
        <p>{item[header.fieldName]}</p>
        <SvgWithBranding type='download-file-SVG' />
      </div>
    );
  } else if (
    typeof item[header.fieldName] === 'string' &&
    item[header.fieldName].startsWith('http')
  ) {
    if (hasFileModal) {
      return (
        <span
          className={styles['link-file']}
          onClick={(e) => {
            e.stopPropagation();
            header.onOpenFileModal?.(item[header.fieldName]);
          }}
          role='button'
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              header.onOpenFileModal?.(item[header.fieldName]);
            }
          }}
        >
          {item[header.fieldName]}
        </span>
      );
    }
    return (
      <a className={styles.link} href={item[header.fieldName]} target='_blank'>
        {item[header.fieldName]}
      </a>
    );
  } else if (header.fieldName === 'type') {
    return (
      <span>
        {1 === item[header.fieldName]
          ? 'GET'
          : 2 === item[header.fieldName]
            ? 'POST'
            : 3 === item[header.fieldName]
              ? 'DELETE'
              : 'PUT'}
      </span>
    );
  } else if (header.isBadge) {
    return renderBadge(item, header);
  } else if (header.isDuration) {
    const durationMs = Math.round(item[header.fieldName] * 1000);
    return <span className={styles['duration']}>{durationMs}ms</span>;
  } else if (header.isFileLink) {
    return renderFileLink(item, header);
  } else {
    return renderItem(item, header);
  }
};
